// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"89452dce","186":"02ea2ae6","215":"3fae8b49","372":"220d2891","377":"84fdbf13","738":"8a6cb965","841":"e1fa4591","851":"1b63d504","856":"2558c52c","987":"f2f09903"}[chunkId] + ".chunk.js";
};